import { ApolloClient, ApolloProvider, InMemoryCache, split, HttpLink } from '@apollo/client';
import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { getMainDefinition } from '@apollo/client/utilities';
import { createClient } from 'graphql-ws';
import { useAtomValue } from 'jotai';
import * as state from '../state';
import { PropsWithChildren, useMemo } from 'react';

export const ConfiguredApolloProvider = ({ children }: PropsWithChildren<object>) => {
  const token = useAtomValue(state.auth0TokenState);
  const VITE_APP_API_URL = import.meta.env.VITE_APP_API_URL;
  const VITE_APP_WS_URL = import.meta.env.VITE_APP_WS_URL;

  const client = useMemo(() => {
    const httpLink = new HttpLink({
      uri: `${VITE_APP_API_URL}/graphql`,
      headers: {
        authorization: `Bearer ${token}`,
      },
    });

    const wsLink = new GraphQLWsLink(
      createClient({
        url: VITE_APP_WS_URL,
        connectionParams: {
          authorization: `Bearer ${token}`,
        },
      })
    );

    const splitLink = split(
      ({ query }) => {
        const definition = getMainDefinition(query);
        return definition.kind === 'OperationDefinition' && definition.operation === 'subscription';
      },
      wsLink,
      httpLink
    );

    return new ApolloClient({
      link: splitLink,
      cache: new InMemoryCache(),
      defaultOptions: {
        watchQuery: { fetchPolicy: 'no-cache' },
        query: { fetchPolicy: 'no-cache' },
        mutate: { fetchPolicy: 'no-cache' },
      },
    });
  }, [VITE_APP_API_URL, VITE_APP_WS_URL, token]);

  return <ApolloProvider client={client}>{children}</ApolloProvider>;
};
